"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var DropDownIcon = function DropDownIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 8
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.fillColor,
    d: "M6.364 4.95 11.314 0l1.414 1.414-6.364 6.364L0 1.414 1.414 0z"
  }));
};
var _default = DropDownIcon;
exports.default = _default;